import { ClientAccessSettings } from '@models/client.model';

export type ClientTabId =
  | 'tasks'
  | 'projectFeed'
  | 'documents'
  | 'evidence'
  | 'incidents';

/** Fixed display order (story-128 UX), each paired with the checklist key that turns it on. */
const CLIENT_TAB_ORDER: { id: ClientTabId; key: keyof ClientAccessSettings }[] = [
  { id: 'tasks', key: 'tasks' },
  { id: 'projectFeed', key: 'activity' },
  { id: 'documents', key: 'documents' },
  { id: 'evidence', key: 'evidence' },
  { id: 'incidents', key: 'incidents' },
];

/**
 * Sprint 43, story-224. The tabs a CLIENT sees on project detail, derived from the CLIENT's own
 * least-exposure checklist (`null` = unlinked CLIENT = every key OFF). A tab is shown iff its key
 * is ON. `scheduleDates`, `priceTotals` and the rest never create a tab; Visitors and Invoices
 * are never offered to a CLIENT (a client Invoices tab is a separate backend + web story).
 */
export const getClientVisibleTabs = (
  access: Partial<ClientAccessSettings> | null | undefined,
): ClientTabId[] =>
  access
    ? CLIENT_TAB_ORDER.filter(({ key }) => Boolean(access[key])).map(
        ({ id }) => id,
      )
    : [];
